import { Dialog } from '@pocketlaw/tetris';
export function PickerDialog(props) {
    const { children } = props;
    return (<Dialog size="large" height="80dvh">
      {children}
    </Dialog>);
}
